module.exports = {"name":"Insert name of the Site in here.","base":"/custombase"}


//////////////////
// WEBPACK FOOTER
// ./src/config/site.json
// module id = 816
// module chunks = 2